import IMGUploadComponent from '../../../../../components/IMGUploadComponent'
import ControlledRowTextField from '../../../../../components/ControlledRowTextField'
import { useForm } from 'react-hook-form'

function CartPersonDetails() {
    const {
        control,
        handleSubmit,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        formState: { errors },
      } = useForm({
        
      });

      const onSubmit = (data: any) => {
      };

  return (
    <div>
       <form className="auth-login-form mt-3" onSubmit={handleSubmit(onSubmit)}>
            <IMGUploadComponent
              imageUrl=""
              onUpload={(e: any) => {}}
            />
            <hr />
            <ControlledRowTextField
              label={"Email Address"}
              inputName={"displayName"}
              inputType={"text"}
              placeholder={"Enter email..."}
              isRequired={true}
              control={control}
             
            />
            <hr />

            <ControlledRowTextField
              label={"Full Name"}
              inputName={"displayName"}
              inputType={"text"}
              placeholder={"Enter full name..."}
              isRequired={true}
              control={control}
             
            />
          <hr />

          <ControlledRowTextField
              label={"Mobile Number"}
              inputName={"displayName"}
              inputType={"text"}
              placeholder={"Enter mobile number..."}
              isRequired={true}
              control={control}
             
            />
        
          </form>
    </div>
  )
}

export default CartPersonDetails